import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { endpoint } from '../../resource/Constant';
import { useAuth } from './AuthProvider';
import { toast } from 'react-toastify';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import './login.css';
import { Backdrop } from '@mui/material';

export default function Login_Page() {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formobj, setFormobj] = useState({
    company_email: undefined,
    password: undefined
  });
  const { login } = useAuth();
  const navigate = useNavigate();

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const onLoginFormsubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    axios
      .post(endpoint + '/api/login', { ...formobj })
      .then((res) => {
        localStorage.setItem('authToken', res.data.access_token);
        setLoading(false);
        login();
        navigate('/createinterview');
      })
      .catch((e) => {
        toast.error(`Wrong email or password`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      });
  };
  useEffect(() => {
    if (localStorage.getItem('authToken')) {
      login();
      navigate('/createinterview');
    }
  }, []);
  document.body.style.backgroundColor = '#e0e0e0';
  return (
    <div
      style={{
        height: '100vh', // full screen height
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: "'Roboto', sans-serif"
        // backgroundSize : 'cover',
        // backgroundImage : `url(${bgImage})`,
        // backgroundRepeat : 'none,'
      }}
    >
      <div className="login-form">
        <h2 style={{ color: '#008267', marginBottom: '20px' }}>Login</h2>

        <form onSubmit={onLoginFormsubmit}>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="email"
              placeholder="Company Email"
              className="form-control"
              value={formobj.company_email}
              onChange={(e) => {
                setFormobj((prev) => ({
                  company_email: e.target.value,
                  password: prev.password
                }));
              }}
              style={{
                height: '50px',
                width: '100%',
                padding: '10px',
                borderRadius: '5px',
                border: '1px solid #ddd',
                marginBottom: '10px',
                fontSize: '16px'
              }}
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
          </div>

          {/* Password Input with Toggle */}
          <div style={{ marginBottom: '20px', position: 'relative' }}>
            <input
              type={passwordVisible ? 'text' : 'password'}
              placeholder="Password"
              className="form-control"
              value={formobj.password}
              onChange={(e) => {
                setFormobj((prev) => ({
                  company_email: prev.company_email,
                  password: e.target.value
                }));
              }}
              style={{
                height: '50px',
                width: '100%',
                padding: '10px 30px 10px 10px', // Added padding for the icon
                borderRadius: '5px',
                border: '1px solid #ddd',
                marginBottom: '10px',
                fontSize: '16px'
              }}
              id="exampleInputPassword1"
            />
            {/* Password Visibility Toggle Button */}
            <button
              type="button"
              onClick={togglePasswordVisibility}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'transparent',
                border: 'none',
                color: '#6F42C1',
                fontSize: '16px',
                cursor: 'pointer'
              }}
            >
              {passwordVisible ? (
                <i style={{ color: '#007e94' }} class="fa-solid fa-eye"></i>
              ) : (
                <i style={{ color: '#007e94' }} class="fa-solid fa-eye-slash"></i>
              )}
            </button>
          </div>

          <Link
            to="/"
            style={{
              color: '#007e94',
              textDecoration: 'none',
              fontSize: '14px',
              marginBottom: '20px',
              display: 'block'
            }}
          >
            Forgot Password?
          </Link>

          <div style={{ marginBottom: '20px' }}>
            <button
              type="submit"
              className="btn btn-primary"
              style={{
                backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))',
                border: 'none',
                color: '#fff',
                padding: '10px 20px',
                fontSize: '16px',
                width: '100%',
                borderRadius: '5px',
                cursor: 'pointer',
                transition: 'background-color 0.3s'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = 'rgb(45 82 126)')}
              onMouseOut={(e) => (e.target.style.backgroundColor = 'rgb(65 90 119)')}
            >
              Submit
            </button>
          </div>
        </form>

        <div>
          <p style={{ fontSize: '14px' }}>
            Don't have an account?{' '}
            <Link
              to="/signup"
              style={{
                color: '#007e94',
                textDecoration: 'none'
              }}
            >
              Sign Up
            </Link>
          </p>
        </div>
      </div>
      <Backdrop open={loading}>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
      </Backdrop>
    </div>
  );
}
